import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { BRAND_LOGOS } from '../constants/media';
import { useLanguage } from '../contexts/LanguageContext';
import { renderRich } from '../utils/richText';
export function BrandsSection() {
  const {
    t
  } = useLanguage();
  return <section className="w-full border-t border-slate-200 bg-white" data-id="element-10" data-mp="3ubxdfxbdezq9">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:py-28" data-id="element-11" data-mp="34um95vj8tg1">
        <div data-id="element-12" data-mp="8249cevg8t0p">
          <h2 className="text-[clamp(1.9rem,3.6vw,2.75rem)] font-extrabold leading-tight tracking-[-0.03em] text-slate-900" data-id="element-13" data-mp="81uk4ti8apw2">
            {t.brands.titleLead}
            <br data-id="element-14" data-mp="h4lxiyunzvqc" />
            {t.brands.titleRest}
            <span className="text-blue-600" data-id="element-15" data-mp="h29eeid67fbp">{t.brands.titleAccent}</span>
          </h2>
          <p className="mt-7 max-w-[520px] text-[17px] leading-relaxed text-slate-600" data-id="element-16" data-mp="2dygnngvxou6h">
            {renderRich(t.brands.body)}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-5 sm:grid-cols-3" data-id="element-17" data-mp="2jsxumywnd01b">
          {BRAND_LOGOS.map((brand, i) => <motion.div key={brand.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: i * 0.06
        }} whileHover={{
          y: -4
        }} className="group relative flex h-[150px] flex-col items-center justify-center overflow-hidden rounded-2xl border border-slate-200 bg-white px-5 shadow-[0_8px_24px_-16px_rgba(15,23,42,0.35)] transition-colors hover:border-blue-300" data-id="element-18" data-mp="2f0wlhlurzpfi" data-mpi={i}>
              <span aria-hidden="true" className="pointer-events-none absolute -right-8 -top-10 h-24 w-24 rounded-full bg-blue-500/10 blur-xl transition-opacity group-hover:bg-blue-500/20" data-id="element-19" data-mp="2osajtqazqj72" />
              <span aria-hidden="true" className="pointer-events-none absolute -bottom-10 -left-8 h-20 w-20 rounded-full bg-blue-400/10 blur-xl" data-id="element-20" data-mp="1db10r4vrxt6a" />
              <span aria-hidden="true" className="absolute inset-x-0 top-0 h-[3px] bg-blue-600 opacity-0 transition-opacity group-hover:opacity-100" data-id="element-21" data-mp="1jsc8829mhg83" />
              <img src={brand.src} alt={`${brand.name} logo`} className="relative max-h-[54px] w-full object-contain" loading="lazy" data-id="element-22" data-mp="1aquyd1mt6aru" />
              <span className="relative mt-4 rounded-full bg-slate-100 px-3 py-1 text-[12px] font-bold uppercase tracking-wide text-slate-500 transition-colors group-hover:bg-blue-50 group-hover:text-blue-600" data-id="element-23" data-mp="10vb0i9oop20g">
                {brand.name}
              </span>
            </motion.div>)}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.3
        }} whileHover={{
          y: -4
        }} className="relative flex h-[150px] flex-col items-center justify-center gap-3 overflow-hidden rounded-2xl border border-blue-200 bg-blue-600 px-4 text-center shadow-[0_10px_30px_-18px_rgba(37,99,235,0.9)]" data-id="element-24" data-mp="d57aj54f50rx">
            <span aria-hidden="true" className="pointer-events-none absolute -right-6 -top-8 h-24 w-24 rounded-full bg-white/15 blur-xl" data-id="element-25" data-mp="3fi7cmh7sbzg" />
            <SparklesIcon size={22} className="relative text-white" aria-hidden="true" data-id="element-26" data-mp="cgq593ftjat0" />
            <span className="relative text-[15px] font-bold text-white" data-id="element-27" data-mp="r5cj10psrui4">
              {t.brands.more}
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}